// import { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";

import logo from "../../public/logo-1.webp";
import profile from "../../public/profile.png";
// // import image1 from "../../public/image1.png";
// import useSWR from "swr";

// import {
//   ChevronLeft,
//   ChevronRight,
//   LayoutDashboard,
//   Handshake,
//   User,
//   Phone,
//   Briefcase,
//   CheckSquare,
//   Calendar,
//   BarChart,
//   PieChart,
//   HeartHandshake,
//   FileClock,
//   LogOut,
//   Settings,
// } from "lucide-react";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { useUserContext } from "../Context/UserProfile";
// // Map module names to icons
// const iconMap = {
//   Home: LayoutDashboard,
//   "Potential Donor": Handshake,
//   "Existing Donor": User,
//   "Manual Calls": Phone,
//   Payments: FileClock,
//   Deals: Briefcase,
//   Tasks: CheckSquare,
//   Meetings: Calendar,
//   Reports: BarChart,
//   Analytics: PieChart,
//   "Sponsor Child": HeartHandshake,
// };

// // Map subroutes to main sidebar routes
// const subRouteMap = {
//   "/owner-details": "/potential-donor",
//   "/contact-details": "/existing-donor",
//   "/task-details": "/tasks",
//   "/task-edit": "/tasks",
//   "/call-details": "/manual-calls",
//   "/payment-details": "/payments",
//   "/create-lead": "/potential-donor",
//   "/edit-lead": "/potential-donor",
//   // Add more mappings as needed
// };

// export default function Sidebar() {
//   // const [expanded, setExpanded] = useState(true);

//   // Auto-collapse on smaller screens (< 665px)
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth < 665) {
//         setExpanded(false);
//       } else {
//         setExpanded(true);
//       }
//     };

//     handleResize(); // Initial check
//     window.addEventListener("resize", handleResize);

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const [sidebarExpanded, setSidebarExpanded] = useState(true);

//   const navigate = useNavigate();
//   const [showLogoutModal, setShowLogoutModal] = useState(false);

//   useEffect(() => {
//     function parseQueryToObj(url) {
//       const queryStartIndex = url.indexOf("?");
//       if (queryStartIndex !== -1) {
//         const queryString = url.substring(queryStartIndex + 1);
//         const pairs = queryString.split("&");
//         const queryObj = {};
//         pairs.forEach((pair) => {
//           const [key, value] = pair.split("=");
//           if (key) {
//             queryObj[decodeURIComponent(key)] = decodeURIComponent(value || "");
//           }
//         });
//         return queryObj;
//       }
//       return {};
//     }

//     const url = window.location.href;
//     const parsedQueryObj = parseQueryToObj(url);
//     const appUrl = parsedQueryObj?.["some_url"];
//     // console.log("ParsedQueryObj",{ parsedQueryObj });
//     if (appUrl) {
//       const pathToNavigate = `/${appUrl.replace("/app", "")}`;
//       setTimeout(() => {
//         navigate(pathToNavigate, { replace: true });
//       }, 0);
//     }
//   }, [navigate]);
//   const location = useLocation();
//   const [expanded, setExpanded] = useState(true);
//   const [routes, setRoutes] = useState([]);

//   const { dealerDetail, error } = useUserContext();
//   // 🚫 BLOCK IF USER IS INACTIVE

//   const handleLogout = () => {
//     // Remove all localStorage keys except those containing 'selectedColumnLeads' or 'selectedColumns'
//     Object.keys(localStorage).forEach((key) => {
//       if (
//         !key.includes("selectedColumnLeads") &&
//         !key.includes("selectedColumns")
//       ) {
//         localStorage.removeItem(key);
//       }
//     });

//     const redirectURL = "/__catalyst/auth/login";
//     window.catalyst.auth.signOut(redirectURL);
//   };

//   // useEffect(() => {
//   //   const fetchSidebarItems = async () => {
//   //     try {
//   //       const res = await axios.get("/server/dealer_backend/getSidebarItems");
//   //       let data = res.data?.data || [];

//   //       // console.log({data})

//   //       const donorType = dealerDetail?.Donor_Type?.trim().toLowerCase();

//   //       // ✅ Conditional hiding based on donor type
//   //       if (donorType === "potential donor") {
//   //         // Hide ONLY "Existing Donor"
//   //         data = data.filter(name => name !== "Existing Donor");
//   //       } else if (donorType === "existing donor") {
//   //         // Hide ONLY "Potential Donor"
//   //         data = data.filter(name => name !== "Potential Donor");
//   //       }

//   //       // ✅ Optional: Also filter by restricted emails
//   //       const restrictedEmailForPotentialDonor = [
//   //         "Annu.kumari@planindia.org",
//   //         "Asha.singh@planindia.org",
//   //         "Nirmal.deka@planindia.org",
//   //       ];

//   //       const restrictedEmailForExistingDonor = [
//   //         "Samar.dhara@planindia.org",
//   //         "Santhosh.uthappa@planindia.org",
//   //       ];

//   //       if (restrictedEmailForPotentialDonor.includes(dealerDetail?.Email)) {
//   //         data = data.filter(name => name !== "Potential Donor");
//   //       }

//   //       if (restrictedEmailForExistingDonor.includes(dealerDetail?.Email)) {
//   //         data = data.filter(name => name !== "Existing Donor");
//   //       }

//   //       // ✅ Format and set final routes
//   //       const formattedRoutes = data.map((name) => ({
//   //         name,
//   //         path: `/${name.toLowerCase().replace(/\s+/g, "-")}`,
//   //         icon: iconMap[name] || LayoutDashboard,
//   //       }));

//   //       setRoutes(formattedRoutes);
//   //     } catch (error) {
//   //       console.error("Failed to fetch sidebar items:", error);
//   //     }
//   //   };

//   //   fetchSidebarItems();
//   // }, [dealerDetail]);

//   // Determine the effective path to match sidebar route

//   const fetcher = (url) => axios.get(url).then((res) => res.data?.data || []);

//   const { data = [], isLoading } = useSWR(
//     "/server/dealer_backend/getSidebarItems",
//     fetcher
//   );

//   // Filter logic (reacts to both data and dealerDetail)
//   let filteredData = data;

//   const donorType = dealerDetail?.Donor_Type?.trim().toLowerCase();

//   const formattedRoutes = filteredData.map((name) => ({
//     name,
//     path: `/${name.toLowerCase().replace(/\s+/g, "-")}`,
//     icon: iconMap[name] || LayoutDashboard,
//   }));

//   const matchedPath =
//     Object.entries(subRouteMap).find(([sub]) =>
//       location.pathname.startsWith(sub)
//     )?.[1] || location.pathname;

//   return (
//     <aside
//       className={`h-screen custom-scroll-bar text-[#5D7285] transition-all overflow-y-auto duration-300 ease-in-out ${
//         expanded ? "w-64" : "w-20"
//       }`}
//       style={{ borderRight: "1px solid #E5E7EB" }}
//     >
//       <div className="flex flex-col h-screen justify-between">
//         <div className="p-4 flex items-center justify-between">
//           <Link to={"/"}>
//             <div className="flex items-center space-x-2">
//               {!expanded && (
//                 <div className="w-10 h-10 border rounded-full overflow-hidden">
//                   <img

//                     src={logo}
//                     alt="SRSG Logo"
//                     className="object-cover w-full h-full"
//                   />
//                 </div>
//               )}
//               {expanded && (
//                 <img
//                   src={logo}
//                   alt="SRSG Logo"
//                   className="h-[50px] w-auto ml-[10px]"
//                 />
//               )}
//             </div>
//           </Link>
//           <button
//             onClick={() => setExpanded(!expanded)}
//             className={`${
//               expanded ? "ml-3" : "ml-0 self-start"
//             } bg-gray-200 hover:bg-gray-300 rounded-full p-1 transition`}
//             aria-label={expanded ? "Collapse sidebar" : "Expand sidebar"}
//           >
//             {expanded ? (
//               <ChevronLeft className="h-5 w-5" />
//             ) : (
//               <ChevronRight className="h-5 w-5" />
//             )}
//           </button>
//         </div>

//         {/* Menu navigation */}
//         <nav className="flex-grow overflow-y-auto my-2">
//           <ul className="space-y-1 px-2 mt-3">
//             {formattedRoutes.map((route) => {
//               const isActive = matchedPath.startsWith(route.path);
//               return (
//                 <li key={route.path}>
//                   <Link
//                     to={route.path}
//                     className={`group flex items-center gap-3 px-3 py-2 transition
//                       rounded-md cursor-pointer

//                       ${
//                         isActive
//                           ? "bg-blue-100 text-[#2171B6] font-bold border-l-4 border-[#2171B6] shadow"
//                           : "hover:bg-blue-50 hover:text-[#2171B6]"
//                       }
//                       ${expanded ? "justify-start" : "justify-center"}
//                     `}
//                     aria-current={isActive ? "page" : undefined}
//                   >
//                     <route.icon
//                       className={`h-5 w-5 flex-shrink-0 transition-colors ${
//                         isActive
//                           ? "text-[#2171B6]"
//                           : "text-[#2171B6] group-hover:text-[#2171B6]"
//                       }`}
//                     />
//                     {expanded && (
//                       <span className="transition-opacity duration-150 truncate">
//                         {route.name}
//                       </span>
//                     )}
//                   </Link>
//                 </li>
//               );
//             })}

//             {showLogoutModal && (
//               <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
//                 <div className="bg-white rounded-lg shadow-lg p-6 w-80">
//                   {/* <h2 className="text-lg font-semibold mb-4">Confirm Logout</h2> */}
//                   <p className="mb-6">Are you sure you want to logout?</p>
//                   <div className="flex justify-end space-x-4">
//                     <button
//                       className="px-4 py-2 text-gray-700 hover:text-black"
//                       onClick={() => setShowLogoutModal(false)}
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
//                       onClick={handleLogout}
//                     >
//                       Logout
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}

//             {/* Logout */}
//             <li className="mt-2">
//               <button
//                 className={`flex w-full items-center gap-3 px-3 py-2 text-red-600 rounded-md hover:bg-red-100 hover:text-red-700 transition justify-${
//                   expanded ? "start" : "center"
//                 }`}
//                 onClick={() => setShowLogoutModal(true)}
//               >
//                 <LogOut className="h-5 w-5" />
//                 {expanded && <span className="font-medium">Logout</span>}
//               </button>
//             </li>
//           </ul>
//         </nav>

//         <div
//           className={`p-2 border-t border-gray-200 transition-all duration-300 ${
//             expanded
//               ? "flex items-center space-x-4"
//               : "flex flex-col items-center space-y-2"
//           }`}
//         >
//           {/* Avatar */}
//           <Link to="/profile">
//             <img
//               src={`profile.png`}
//               alt={dealerDetail?.Name || "User"}
//               className="w-10 h-10 rounded-full object-cover border border-gray-300"
//             />
//           </Link>

//           {/* Name Display */}
//           {dealerDetail?.Name &&
//             (() => {
//               const [firstName, ...lastNameParts] =
//                 dealerDetail.Name.trim().split(" ");
//               const lastName = lastNameParts.join(" ");

//               return (
//                 <div
//                   className={`text-gray-800 font-medium transition-all duration-300 ${
//                     expanded ? "text-l flex flex-col" : "text-center text-xs"
//                   }`}
//                 >
//                   {expanded ? (
//                     <span>Hello {dealerDetail.Name}</span>
//                   ) : (
//                     <>
//                       <div>{firstName}</div>
//                       <div>{lastName}</div>
//                     </>
//                   )}
//                 </div>
//               );
//             })()}

//           {/* Settings Icon */}
//           {/* {expanded && (
//             <button
//               className="ml-auto text-gray-400 hover:text-gray-600 transition"
//               aria-label="Profile settings"
//             // onClick={() => ...}
//             >
//               <Settings className="w-5 h-5" />
//             </button>
//           )} */}
//         </div>

//         {/* Footer */}
//         <div
//           className={`border-t border-gray-200 py-1 px-2 text-xs text-gray-400 ${
//             expanded ? "text-left" : "text-center"
//           }`}
//         >
//           <span>© {new Date().getFullYear()} Extension Technologies</span>
//         </div>
//       </div>
//     </aside>
//   );
// }











import { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight, LayoutDashboard, LogOut } from "lucide-react";
import { useUserContext } from "../Context/UserProfile";



export default function Sidebar() {
  const [expanded, setExpanded] = useState(true);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { dealerDetail } = useUserContext();

  // Collapse sidebar on small screens
  useEffect(() => {
    const handleResize = () => {
      setExpanded(window.innerWidth >= 665);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    function parseQueryToObj(url) {
      const queryStartIndex = url.indexOf("?");
      if (queryStartIndex !== -1) {
        const queryString = url.substring(queryStartIndex + 1);
        const pairs = queryString.split("&");
        const queryObj = {};
        pairs.forEach((pair) => {
          const [key, value] = pair.split("=");
          if (key) {
            queryObj[decodeURIComponent(key)] = decodeURIComponent(value || "");
          }
        });
        return queryObj;
      }
      return {};
    }

    const url = window.location.href;
    const parsedQueryObj = parseQueryToObj(url);
    const appUrl = parsedQueryObj?.["some_url"];
    console.log("ParsedQueryObj", { parsedQueryObj });
    if (appUrl) {
      const pathToNavigate = `/${appUrl.replace("/app", "")}`;
      console.log({ pathToNavigate });
      setTimeout(() => {
        navigate(pathToNavigate, { replace: true });
      }, 0);
    }
  }, [navigate]);

  // 🚫 BLOCK IF USER IS INACTIVE
  useEffect(() => {
    if (dealerDetail?.Status === "Inactive") {
      navigate("/unauthorized");
    }
  }, [dealerDetail, navigate]);

  if (dealerDetail?.Status === "Inactive") {
    return (
      <div className="flex items-center justify-center h-screen w-full bg-gray-100 text-red-600 text-xl font-semibold">
        You are not allowed to view this data. Please contact admin.
      </div>
    );
  }
  // Logout function
  const handleLogout = () => {
    Object.keys(localStorage).forEach((key) => {
      if (!key.includes("selectedColumnLeads") && !key.includes("selectedColumns")) {
        localStorage.removeItem(key);
      }
    });

    const redirectURL = "/__catalyst/auth/login";
    if (window?.catalyst?.auth?.signOut) {
      window.catalyst.auth.signOut(redirectURL);
    }
  };

  // ---- Only one route ----
  const route = {
    name: "Logistic Request", // change this to "Vendor Logistic" if needed
    path: "/Vendor",
    icon: LayoutDashboard,
  };

  const isActive = location.pathname.startsWith(route.path);

  return (
    <aside
      className={`h-screen flex flex-col text-[#5D7285] custom-scroll-bar transition-all overflow-y-auto duration-300 ease-in-out ${expanded ? "w-64" : "w-20"
        }`}
      style={{ borderRight: "1px solid #E5E7EB" }}
    >
      {/* Logo + Toggle */}
      <div className="p-4 flex items-center justify-between">
        <Link to={"/"}>
          <div className="flex items-center space-x-2">
            {!expanded && (
              <div className="w-10 h-10 border rounded-full overflow-hidden">
                <img
                  src={logo}   // ✅ direct path
                  alt="SRSG Logo"
                  className="object-cover w-full h-full"
                />
              </div>
            )}
            {expanded && (
              <img
                src={logo}    // ✅ direct path
                alt="SRSG Logo"
                className="h-[50px] w-auto ml-[10px]"
              />
            )}
          </div>
        </Link>


        <button
          onClick={() => setExpanded(!expanded)}
          className={`${expanded ? "ml-3" : "ml-0 self-start"
            } bg-gray-200 hover:bg-gray-300 rounded-full p-1 transition`}
        >
          {expanded ? <ChevronLeft className="h-5 w-5" /> : <ChevronRight className="h-5 w-5" />}
        </button>
      </div>

      {/* Navigation (only one item) */}
      <nav className="flex-grow overflow-y-auto my-2">
        <ul className="space-y-1 px-2 mt-3">
          <li>
            <Link
              to={route.path}
              className={`group flex items-center gap-3 px-3 py-2 rounded-md transition
                ${isActive
                  ? "bg-blue-100 text-[#2171B6] font-bold border-l-4 border-[#2171B6] shadow"
                  : "hover:bg-blue-50 hover:text-[#2171B6]"
                }
                ${expanded ? "justify-start" : "justify-center"}`}
            >
              <route.icon
                className={`h-5 w-5 flex-shrink-0 ${isActive ? "text-[#2171B6]" : "text-[#2171B6] group-hover:text-[#2171B6]"
                  }`}
              />
              {expanded && <span className="truncate">{route.name}</span>}
            </Link>
          </li>
        </ul>
      </nav>

      {/* ---- Logout Button at the very bottom ---- */}
      <div className="mt-auto border-t border-gray-200">
        <button
          className={`flex w-full items-center gap-3 px-3 py-2 text-red-600 rounded-md hover:bg-red-100 hover:text-red-700 transition ${expanded ? "justify-start" : "justify-center"
            }`}
          onClick={() => setShowLogoutModal(true)}
        >
          <LogOut className="h-5 w-5" />
          {expanded && <span className="font-medium">Logout</span>}
        </button>
      </div>

      {/* Logout Modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-80">
            <p className="mb-6">Are you sure you want to logout?</p>
            <div className="flex justify-end space-x-4">
              <button className="px-4 py-2 text-gray-700" onClick={() => setShowLogoutModal(false)}>
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Footer with profile */}
      <div
        className={`p-2 border-t border-gray-200 transition-all duration-300 ${expanded ? "flex items-center space-x-4" : "flex flex-col items-center space-y-2"
          }`}
      >
        <Link to="/profile">
          <img
            src={profile}
            alt={dealerDetail?.Name || "User"}
            className="w-10 h-10 rounded-full object-cover border border-gray-300"
          />
        </Link>

        {dealerDetail?.Name && (
          <div
            className={`text-gray-800 font-medium ${expanded ? "text-l flex flex-col" : "text-xs text-center"
              }`}
          >
            {expanded ? (
              <span>Hello {dealerDetail.Name}</span>
            ) : (
              <>
                <div>{dealerDetail.Name.split(" ")[0]}</div>
                <div>{dealerDetail.Name.split(" ").slice(1).join(" ")}</div>
              </>
            )}
          </div>
        )}
      </div>

      <div
        className={`border-t border-gray-200 py-1 px-2 text-xs text-gray-400 ${expanded ? "text-left" : "text-center"
          }`}
      >
        © {new Date().getFullYear()} Extension Technologies
      </div>
    </aside>
  );
}
